<br>
<div class="col-md-10">
  <p-table #dt [columns]="cols" [value]="electablesigns" [paginator]="false" [autoLayout]="true">
    <ng-template pTemplate="caption">
      <p class="rubrik">Hantera Electable Signs</p>
      <div class="d-flex justify-content-start gap-2"><button class="btn border" (click)="resetFilter()" title="Rensa filter">Rensa filter</button><button class="btn border"
            (click)="exportToCSV()">Excel</button><button class="btn btn-border" (click)="add()">Lägg till</button></div>
      <br>
      <div>
        <i class="fa fa-search" style="margin:4px 4px 0 0"></i>
        <input type="text" #globalfilter pInputText size="50" placeholder="Globalt filter" (input)="dt.filterGlobal($event.target.value, 'contains')" style="width:auto">
      <span class="ms-2">Antal poster: {{electablesigns?.length}}</span>
      
      </div>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th *ngFor="let col of columns" [pSortableColumn]="col.field">
          {{col.header}}
          <p-sortIcon [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order">
          </p-sortIcon>
        </th>
        <th>Action</th>
      </tr>
      
      <tr *ngIf="institutiontypes.length > 0">
        <th *ngFor="let col of columns" [ngSwitch]="col.field">        
          <p-select appendTo="body" *ngSwitchCase="'institutionTypeIdName'" [options]="institutiontypes" [style]="{'width':'100%', 'height':'40px'}" (onChange)="dt.filter($event.value, 'institutionTypeId', 'equals')"></p-select>
          <input *ngSwitchCase="'shortName'" pInputText type="text" [value]="dt.filters['shortName'] ? dt.filters['shortName'].value : ''" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:100%">
          <input *ngSwitchCase="'signName'" pInputText type="text" [value]="dt.filters['signName'] ? dt.filters['signName'].value : ''" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:100%">
          <input *ngSwitchCase="'signAbbreviation'" pInputText type="text" [value]="dt.filters['signAbbreviation'] ? dt.filters['signAbbreviation'].value : ''" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:100%">
        </th>
        <th style="text-align: center;"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-i="rowIndex" let-columns="columns">
      <tr [pSelectableRow]="rowData">
        <td *ngFor="let col of columns">
          {{rowData[col.field]}}
        </td>
        <td style="text-align: center;"><i class="fa fa-trash" style="font-size:12px;" (click)="remove(rowData)" title="Radera Electable Sign"></i></td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-dialog header="Lägg till Electable Sign" [(visible)]="display" [closable]="true" appendTo="body" position="center" modal="true" maximizable="true">
  <app-admin-electable-signs-add [institutiontypes]="institutiontypes" [signlist]="signlist" [institutionlist]="institutionlist" (doSave)="saveElectableSigns($event)" (doCancel)="cancelAdd()"></app-admin-electable-signs-add>
</p-dialog>
